<template>
    <div class="FTSsearch">
        <i class="fa fa-search"></i>
        <input type="text" v-model="value" @input="updateValue($event.target.value)" placeholder="Search"/>
    </div>
</template>

<script>
    export default {
        name: "FTSsearch",
        props: {
            value: String
        },
        methods: {
            updateValue(value) {
                this.$emit('input',value)
            }
        }
    }
</script>

<style lang="scss">

    .FTSsearch {
        display: flex;
        align-items: center;
        width: 300px;
        height: 35px;
        padding: 6px 18px;
        background-color: #e4e5e6;
        border: 1px solid #c9cfd4;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        border-radius: 5px;
        input {
            flex-grow: 1;
            margin-left: 14px;
            background-color: #e4e5e6;
            border: none;
            &:focus {
                outline: none;
            }
        }
    }

    .dark-theme {
        .FTSsearch {
            background-color: #515b65;
            border: 1px solid #1a1c1d;
            input {
                background-color: #515b65;
                color: #edeeef;
                &::placeholder {
                    color: #edeeef;
                }
            }
        }
    }

</style>
